import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'underscore';
import { SelectionMode } from '@fluentui/react';
import { GridContextProvider, reducers, middlewares } from '@bingads-webui-grid/grid-context';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { perfMarkerMiddlewareFactory } from '@bingads-webui-grid/perf-marker-middleware';
import { getAggregatedRowConfigs } from '@bingads-webui-grid/well-known';
import { AssetGroupsGrid as Grid } from './asset-groups-grid';


export const AssetGroupsGrid = (props) => {
  const { i18n, preferenceService } = props;
  const isAggregatedRowsEnabled = get(props, ['permissions', 'dynamic', 'AssetGroupAdditions']);
  const isPreferenceSortingEnabled = get(props, ['permissions', 'dynamic', 'AssetGroupAdditionsPhaseTwo']);

  const perfMarkerMiddleware = perfMarkerMiddlewareFactory(props.perfMarker, 'Asset_Groups_Grid');
  const { aggregatedRowReducer } = reducers;
  const { campaignPreferenceFactory } = middlewares;

  let initialGridContext = {
    selectionMode: SelectionMode.multiple,
    middlewares: [perfMarkerMiddleware],
    reducers: [],
  };

  if (isAggregatedRowsEnabled) {
    const aggregatedRowConfig = getAggregatedRowConfigs({
      i18n,
      showFilter: true,
      showDeletedRow: true,
      showOverall: true,
    });

    initialGridContext.reducers.push(aggregatedRowReducer);
    initialGridContext.aggregatedRowConfig = aggregatedRowConfig;
  }

  if (isPreferenceSortingEnabled) {
    const { getGridPreference, preferenceMiddleware } = campaignPreferenceFactory('Asset_Groups_Grid', preferenceService);
    initialGridContext.middlewares.push(preferenceMiddleware);
    initialGridContext = {
      ...initialGridContext,
      ...(getGridPreference()),
    };
  }

  return (
    <GridContextProvider {...initialGridContext}>
      <Grid {...props} />
    </GridContextProvider>
  );
};

AssetGroupsGrid.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  preferenceService: PropTypes.shape({}).isRequired,
};
